import { StackFrame } from './StackFrame';

export class CallDetail {
  constructor(private readonly args: object | null, private readonly stackTrace: StackFrame[] | null) {}

  getArguments() {
    return this.args;
  }

  getStackTrace() {
    return this.stackTrace;
  }
}
